import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-remove-file",on:{"click":function($event){return _vm.remove()}}},[_c(VIcon,{attrs:{"size":"20","color":"ic_invalid"}},[_vm._v(" mdi-delete ")]),_vm._v(" "+_vm._s(_vm.$t('components.buttons.remove_file'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }